import { useEffect, useState } from "react";
import { Periods } from "../../helpers/enums";
import { controlStyle } from "../../helpers/constants";
import { getDateRange } from "../../helpers/general";

const filters = [
  { label: "Dernier", value: "latest" },
  { label: "Aujourd'hui", value: Periods.today },
  { label: "Hier", value: Periods.yesterday },
  { label: "Derniers 7 jours", value: Periods.last7Days },
  { label: "Mois en cours", value: Periods.currentMonth },
  { label: "Derniers 3 mois", value: Periods.last3Months },
];

type DateFilterProps = {
  onChange: (dates: Dates) => void;
  onPeriodChange?: (period: Periods | null) => void;
  defaultPeriod?: Periods;
  label?: string;
};

export default function DateFilters(props: DateFilterProps) {
  const { onChange, onPeriodChange, label, defaultPeriod } = props;
  const [selectedDate, onSelectDate] = useState<string | null>(
    defaultPeriod ?? null,
  );

  useEffect(() => {
    if (defaultPeriod) {
      onSelectDate(defaultPeriod);
    }
  }, [defaultPeriod]);

  useEffect(() => {
    if (selectedDate !== "latest" && selectedDate) {
      const dateRange = getDateRange(selectedDate as Periods);
      onChange({
        from: dateRange[0].toISOString(),
        to: dateRange[1].toISOString(),
      });
      onPeriodChange?.(selectedDate as Periods);
    } else {
      onChange({ from: "", to: "" });
      onPeriodChange?.(null);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedDate]);

  return (
    <div className="d-flex flex-column gap-1">
      {label && (
        <label
          htmlFor="filter"
          className="text-muted mb-0"
          style={{ fontSize: 11 }}
        >
          {label}
        </label>
      )}
      <select
        name="date_filter"
        id="filter"
        className="form-select px-3"
        style={{ ...controlStyle, width: "auto", minWidth: 160 }}
        onChange={(e) => onSelectDate(e.target.value)}
        value={selectedDate ?? "latest"}
      >
        {filters.map((filter) => (
          <option value={filter.value} key={filter.value}>
            {filter.label}
          </option>
        ))}
      </select>
    </div>
  );
}
